import localIcon from './localIcon';
import clipboard from '@/utils/clipboard';
export default {
  name: 'icon',
  data() {
    return {
      localIcon
    };
  },
  methods: {
    handleCopy(item, event) {
      clipboard(`<svg-icon :icon="${item}" :size="30" />`, event);
    }
  }
};